import * as React from 'react';
const Repeat = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-repeat", ...props },
    React.createElement("polyline", { points: "17 1 21 5 17 9" }),
    React.createElement("path", { d: "M3 11V9a4 4 0 0 1 4-4h14" }),
    React.createElement("polyline", { points: "7 23 3 19 7 15" }),
    React.createElement("path", { d: "M21 13v2a4 4 0 0 1-4 4H3" })));
export default Repeat;
//# sourceMappingURL=Repeat.js.map